import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function smoothScrollToTop(duration = 500) {
  const start = window.scrollY || window.pageYOffset;
  const startTime = performance.now();
  let animationFrameId;

  // Handler to cancel animation on user scroll
  function cancelOnUserScroll() {
    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
      removeListeners();
    }
  }

  function removeListeners() {
    window.removeEventListener('wheel', cancelOnUserScroll, { passive: true });
    window.removeEventListener('touchstart', cancelOnUserScroll, { passive: true });
    window.removeEventListener('keydown', cancelOnUserScroll, { passive: true });
  }

  window.addEventListener('wheel', cancelOnUserScroll, { passive: true });
  window.addEventListener('touchstart', cancelOnUserScroll, { passive: true });
  window.addEventListener('keydown', cancelOnUserScroll, { passive: true });

  function scrollStep(currentTime) {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    // easeInOutQuad easing function
    const easeProgress = progress < 0.5
      ? 2 * progress * progress
      : -1 + (4 - 2 * progress) * progress;

    window.scrollTo(0, start * (1 - easeProgress));

    if (progress < 1) {
      animationFrameId = requestAnimationFrame(scrollStep);
    } else {
      removeListeners();
    }
  }

  animationFrameId = requestAnimationFrame(scrollStep);
}

const ScrollToTop = () => {
  const { pathname } = useLocation();

//   useEffect(() => {
//     // window.scrollTo({ top: 0, left: 0 });
//     window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
//   }, [pathname]);

  useEffect(() => {
    // Scroll smoothly to top over 800ms when route changes
    smoothScrollToTop(800);
  }, [pathname]);

  return null;
};

export default ScrollToTop;